import React from 'react';
import * as PropTypes from 'prop-types';
import FormGroup from '@mui/material/FormGroup';
import { getIn, useFormikContext } from 'formik';

import { withStyles } from '~/assets/withStyles';
import FormControl from '~/components/core/Atomic/FormControl';
import FormControlLabel from '~/components/core/Atomic/FormControlLabel';
import FormHelperText from '~/components/core/Atomic/FormHelperText';
import Typography from '~/components/core/Atomic/Typography';
import Switch, { SIZES } from '~/components/ui/atoms/Switch';

import { ShowOnlyTextField } from '../../TextFieldFormik';

import styles, { useStyles } from '../../../assets/styles';

function SwitchFormik(props) {
  const { id, label, showOnly, disabled, onChange, className, withShowOnlyText, labelStyle, hideErrorGap, reverse } =
    props;
  const { classes } = useStyles();

  const { values, touched, errors, setFieldTouched, setFieldValue } = useFormikContext();

  if (showOnly && !withShowOnlyText) {
    return <ShowOnlySwitch label={label} showOnlyValueComponent={getIn(values, id)} />;
  }

  if (showOnly && withShowOnlyText) {
    return (
      <ShowOnlyTextField classes={classes} showOnlyValueComponent={getIn(values, id) ? 'Yes' : 'No'} label={label} />
    );
  }

  const handleChange = (event, switched) => {
    if (onChange) {
      return onChange(event, switched);
    }
    setFieldValue(id, reverse ? !switched : switched);
  };

  const checkedValue = reverse ? !getIn(values, id) : !!getIn(values, id);

  return (
    <>
      <FormControl component="fieldset" error={getIn(errors, id) && getIn(touched, id)}>
        <FormGroup row>
          <FormControlLabel
            control={
              <Switch
                id={id}
                name={id}
                size={SIZES.medium}
                disabled={disabled}
                onChange={handleChange}
                onBlur={() => setFieldTouched(id, true)}
                className={className}
                checked={checkedValue}
              />
            }
            label={label}
            style={Object.assign({ margin: '0px', display: 'flex', alignItems: 'center' }, labelStyle ?? {})}
          />
        </FormGroup>
        {!hideErrorGap &&
          (getIn(errors, id) && getIn(touched, id) ? (
            <FormHelperText>{getIn(errors, id)}</FormHelperText>
          ) : (
            <div style={{ height: '18px' }} />
          ))}
      </FormControl>
    </>
  );
}

SwitchFormik.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  showOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  hideErrorGap: PropTypes.bool,
  withShowOnlyText: PropTypes.bool,
  labelStyle: PropTypes.object,
  reverse: PropTypes.bool,
};

function ShowOnlySwitch(props) {
  const { label, showOnlyValueComponent } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.showField}>
      <div className={classes.showValueField} style={{ display: 'inline-flex', alignItems: 'center' }}>
        <Switch checked={showOnlyValueComponent} disabled size={SIZES.medium} />
        <Typography display="block" variant="caption">
          {label}
        </Typography>
      </div>
    </div>
  );
}

ShowOnlySwitch.propTypes = {
  // Mirrors SwitchFormik's own `label`, which is forwarded here verbatim: optional, and a node
  // rather than a string.
  label: PropTypes.node,
  showOnlyValueComponent: PropTypes.node.isRequired,
};

export { ShowOnlySwitch };
export default withStyles(SwitchFormik, styles);
